import { useQueryParam } from './useQueryParam';

export const useQueryParamBoolean = (paramName: string, callback: (value: boolean) => void) =>
  useQueryParam(paramName, (paramValue) => {
    callback(paramValue ? Boolean(paramValue) && paramValue !== 'false' : false);
  });
